webpackJsonp([144342403179678],{

/***/ 390:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"forde.blog","author":"Michael Forde"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/hello-world/index.md absPath of file >>> MarkdownRemark","html":"<p>This is my first post on my new blog!</p>\n<p>I’m sure I’ll write a lot more interesting things in the future.</p>","frontmatter":{"title":"Hello World","date":"July 08, 2021"}}},"pathContext":{"slug":"/hello-world/","previous":null,"next":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---hello-world-f3bcc376050f062cb4f6.js